<template>
  <div class="mt-5 action-recap-table">
    <!-- Filter -->
    <div class="row align-items-center justify-content-between mt-n3">
      <div class="col-md-4">
        <!-- <span class="d-block d-sm-none">
          
        </span> -->
      </div>
      <div class="col-md-6 d-flex justify-content-end">
        <div class="d-flex justify-content-end align-items-center">
          <span class="text-medium mr-2"
            >Periode : {{ monthName + " " + year }}</span
          >
          <button
            class="btn btn-primary mr-1 action-recap-export"
            @click="$bvModal.show('modal-action')"
          >
            Ekspor <i class="fas fa-print px-0 ml-1"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- <div class="d-flex justify-content-end align-items-center mt-5" v-if="purpose != 'modal'">
      <button
        class="btn btn-primary mr-1"
        @click="$bvModal.show('modal-action')"
        
      >
        Expor <i class="fas fa-print px-0 ml-1"></i>
      </button>
    </div> -->

    <medhop-data-table
      summary-title="Rekap Tindakan Perawat"
      v-if="nullMessage == false"
      :items="reportItems"
      :fields="reportFields"
      class="action-recap-data-table"
      bordered
    >
      <template #head()="data"><span v-html="data.field.labelHtml"></span></template>
      <template #cell()="data"><span v-html="data.value"></span></template>
    </medhop-data-table>

    <div class="row justify-content-center action-recap-table__empty" v-if="nullMessage">
      <span>Data Tidak Ditemukan</span>
    </div>

    <div class="row action-recap-table__notes">
      <div class="col-12 mt-6">
        <span class="text-info"
          ><i class="fas fa-info-circle mr-1 text-info"></i> Catatan</span
        >
        <ul class="ml-6">
          <li>
            <span>A = Asisten</span>
          </li>
          <li>
            <span>O = Omploop</span>
          </li>
          <li>
            <span>P = Perawat</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Modal -->
    <b-modal
      id="modal-action"
      size="xl"
      title="Ekspor Rekap Tindakan Medis Perbulan"
      hide-footer
      body-class="pt-0"
    >
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-start align-items-center">
            <button
              class="btn btn-primary mr-1"
              v-b-tooltip.hover
              title="Print"
              @click="btnPrintOnClick"
            >
              <i class="fas fa-print px-0"></i>
            </button>
            <button
              class="btn btn-info mr-1"
              v-b-tooltip.hover
              title="Download Pdf"
              @click="btnDownloadOnClick"
            >
              <i class="fas fa-file-pdf px-0"></i>
            </button>
            <button
              class="btn btn-warning mr-1"
              v-b-tooltip.hover
              title="Download Excel"
              @click="btnExcelOnClick"
            >
              <i class="fas fa-file-excel px-0"></i>
            </button>
          </div>

          <table class="table table-bordered mt-3" v-if="nullMessage == false">
            <tbody>
              <tr
                v-for="(data, index) in itemData.length"
                :key="index"
                v-bind:style="{ 'background-color': styleBind(index) }"
              >
                <td
                  v-for="(indexData, count) in itemData[index].length"
                  :key="count"
                  class="text-medium"
                  style="max-width: 80px"
                >
                  <span v-html="itemData[index][indexData - 1]"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <!-- end Modal -->

    <!-- PDF -->
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="'Laporan Pendapatan Rumah Sakit'"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="780px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div id="print" class="row">
          <div
            class="col-12 d-flex justify-content-center mt-4"
            v-if="nullMessage == false"
          >
            <span
              >Rekap Tindakan Medis Perawat Klinik
              {{ setting.clinic_name }} (Periode {{ month }} {{ year }})</span
            >
          </div>
          <div class="col-12">
            <table class="table table-bordered mt-3">
              <tbody>
                <tr
                  v-for="(data, index) in itemData.length"
                  :key="index"
                  v-bind:style="{ 'background-color': styleBind(index) }"
                >
                  <td
                    v-for="(indexData, count) in itemData[index].length"
                    :key="count"
                    class="text-medium"
                    style="max-width: 80px"
                  >
                    <span v-html="itemData[index][indexData - 1]"></span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </vue-html2pdf>
    <!-- end PDF -->
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import VueHtml2pdf from "vue-html2pdf";
import XLSX from "xlsx";

export default {
  props: {
    // purpose: String,
    // selectedItem: Array
    month: String,
    monthName: String,
    year: String,
  },
  components: {
    XLSX,
    VueHtml2pdf,
  },
  computed: {
    reportFields() {
      const header = this.itemData[0] || [];
      return header.map((label, index) => ({
        key: `column_${index}`,
        label: String(label || "").replace(/<[^>]+>/g, " "),
        labelHtml: label,
      }));
    },
    reportItems() {
      return (this.itemData || []).slice(1).map((row, rowIndex) => {
        const item = { _rowIndex: rowIndex };
        row.forEach((value, index) => { item[`column_${index}`] = value; });
        return item;
      });
    },
  },

  data() {
    return {
      nullMessage: false,
      currentDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      currentMonth: "",
      // year:"",
      // month:"",
      dates: [],
      // Filter
      date: "",
      menu: false,
      modal: false,
      filter: {
        name: "",
      },
      sumData: {
        service: "",
        employee: "",
        assistant: "",
        omploop: "",
        nurse_action: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "price",
          label: "Harga",
          sortable: true,
        },
        {
          key: "doctor_commission",
          label: "Komisi Dokter",
          sortable: true,
        },
        {
          key: "hospital_income",
          label: "Pendapatan Rumah Sakit",
          sortable: true,
          thClass: "text-truncate",
          thStyle: { maxWidth: "90px", overflowX: "auto" },
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      itemData: [],
      itemExcel: [],

      // User Access
      btn: false,

      // other
      setting: {},
    };
  },

  methods: {
    styleBind(id) {
      if (id == 0) {
        return "#e8e8e8";
      }
    },

    async getSetting() {
      this.setting = await module.get(`settings/${1}`);
    },

    pageOnClick(evt, page) {
      evt.preventDefault();
      this.currentPage = page;
      this.pagination();
    },

    chooseItem(value) {
      this.$emit("chooseItem", value);
    },

    btnExcelOnClick() {
      const data = XLSX.utils.json_to_sheet(this.itemExcel);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(
        wb,
        `Laporan Rekap Tindakan Medis Perawat ${setting.clinic_name} (Periode ${
          this.month + " " + this.year
        }).xlsx`
      );
    },

    async pagination() {
      this.nullMessage = false;

      let filterParams = `?month=${this.month}&year=${this.year}`;

      let response = await module.get(
        "medical-action-monthly",
        `${filterParams}`
      );

      this.items = response;


      const actions = response;

      let newData = {};
      let newStaff = {};
      let result = [];

      // pengumpulan data
      actions.forEach((action, index) => {
        action.action_type_display.forEach((actionDisplay) => {
          if (!newData[actionDisplay.name]) {
            newData[actionDisplay.name] = {};
          }

          action.assistant_display.forEach((A) => {
            if (!newData[actionDisplay.name][A.name]) {
              newData[actionDisplay.name][A.name] = {
                A: 0,
                O: 0,
                P: 0,
              };
            }

            newStaff[A.id] = A;
            newData[actionDisplay.name][A.name].A += 1;
          });

          action.omploop_display.forEach((O) => {
            if (!newData[actionDisplay.name][O.name]) {
              newData[actionDisplay.name][O.name] = {
                A: 0,
                O: 0,
                P: 0,
              };
            }

            newStaff[O.id] = O;
            newData[actionDisplay.name][O.name].O += 1;
          });

          action.nurse_action_display.forEach((P) => {
            if (!newData[actionDisplay.name][P.name]) {
              newData[actionDisplay.name][P.name] = {
                A: 0,
                O: 0,
                P: 0,
              };
            }

            newStaff[P.id] = P;
            newData[actionDisplay.name][P.name].P += 1;
          });
        });
      });

      // bagian nampilin data ke table
      result.push([
        "Tindakan",
        ...Object.values(newStaff).map((staff) => staff.name),
      ]);

      Object.keys(newData).forEach((key) => {
        let newRow = [key];

        Object.values(newStaff).forEach((staff) => {
          newRow.push(
            Object.entries(newData[key][staff.name] || {})
              .map(([type, count]) => {
                return `${type}: ${count}`;
              })
              .join(", ")
          );
        });

        result.push(newRow);
        // this.itemExcel.push(newRow)
      });

      this.itemData = result;

      console.table(result);

      // change data into the format
      let g, h, i;
      for (g = 1; g < this.itemData.length; g++) {
        for (h = 1; h < this.itemData[g].length; h++) {
          if (this.itemData[g][h] != "") {
            // this.itemExcel[g][h] =  result[g][h]
            let res = this.itemData[g][h].split(",");
            for (i = 0; i < res.length; i++) {
              let dataSum = res[i].split(": ");
              res[i] = dataSum[0] + "= <b>" + dataSum[1] + "</b>,";
            }

            let finalText =
              "<ul><li>" +
              res[0] +
              "</li><li>" +
              res[1] +
              "</li><li>" +
              res[2] +
              "</li></ul>";
            this.itemData[g][h] = finalText;

            // let dataSum = res[1]+"= <b>"
          } else {
            this.itemData[g][h] =
              "<ul><li>A= <b>0</b>,</li><li> O= <b>0</b></li>, <li>P= <b>0</b></li></ul>";
            // this.itemExcel[g][h] = "A= 0,O= 0,P= 0"
          }
        }
      }

      // show text data empty in table
      if (this.itemData.length <= 1) {
        this.nullMessage = true;
      }

      this.excel();
    },
    async excel() {
      let dates = this.date.split("-");
      let month = dates[1];
      let year = dates[0];
      let filterParams = `?month=${this.month}&year=${this.year}`;
      let response = await module.get(
        "medical-action-monthly",
        `${filterParams}`
      );

      this.items = response;

      const actions = response;

      let newData = {};
      let newStaff = {};
      let result = [];

      // pengumpulan data
      actions.forEach((action, index) => {
        action.action_type_display.forEach((actionDisplay) => {
          if (!newData[actionDisplay.name]) {
            newData[actionDisplay.name] = {};
          }

          action.assistant_display.forEach((A) => {
            if (!newData[actionDisplay.name][A.name]) {
              newData[actionDisplay.name][A.name] = {
                A: 0,
                O: 0,
                P: 0,
              };
            }

            newStaff[A.id] = A;
            newData[actionDisplay.name][A.name].A += 1;
          });

          action.omploop_display.forEach((O) => {
            if (!newData[actionDisplay.name][O.name]) {
              newData[actionDisplay.name][O.name] = {
                A: 0,
                O: 0,
                P: 0,
              };
            }

            newStaff[O.id] = O;
            newData[actionDisplay.name][O.name].O += 1;
          });

          action.nurse_action_display.forEach((P) => {
            if (!newData[actionDisplay.name][P.name]) {
              newData[actionDisplay.name][P.name] = {
                A: 0,
                O: 0,
                P: 0,
              };
            }

            newStaff[P.id] = P;
            newData[actionDisplay.name][P.name].P += 1;
          });
        });
      });

      // bagian nampilin data ke table
      result.push([
        "Tindakan",
        ...Object.values(newStaff).map((staff) => staff.name),
      ]);
      // excelRes.push(['Tindakan', ...Object.values(newStaff).map((staff) => staff.name)])

      Object.keys(newData).forEach((key) => {
        let newRow = [key];

        Object.values(newStaff).forEach((staff) => {
          newRow.push(
            Object.entries(newData[key][staff.name] || {})
              .map(([type, count]) => {
                return `${type}: ${count}`;
              })
              .join(", ")
          );
        });

        result.push(newRow);
        // excelRes.push(newRow)
        // this.itemExcel.push(newRow)
      });
      this.itemExcel = result;
      // change data into the format
      let g, h, i;
      for (g = 1; g < this.itemExcel.length; g++) {
        for (h = 1; h < this.itemExcel[g].length; h++) {
          if (this.itemExcel[g][h] != "") {
            // this.itemExcel[g][h] =  result[g][h]
            let res = this.itemExcel[g][h].split(",");
            for (i = 0; i < res.length; i++) {
              let dataSum = res[i].split(": ");
              res[i] = dataSum[0] + "= " + dataSum[1] + ",";
            }

            let finalText = "" + res[0] + "" + res[1] + "" + res[2] + "";
            this.itemExcel[g][h] = finalText;

            // let dataSum = res[1]+"= <b>"
          } else {
            this.itemExcel[g][h] = "A= 0, O= 0, P= 0";
            // this.itemExcel[g][h] = "A= 0,O= 0,P= 0"
          }
        }
      }
    },

    chooseMonth(date) {
      // get month name
      this.dates = date.split("-");

      this.$refs.dialog.save(date);
    },

    btnPrintOnClick() {
      this.$htmlToPaper("print");
    },

    btnDownloadOnClick() {
      this.$refs.html2Pdf.generatePdf();
    },

    onProgress($event) {},

    hasStartedGeneration() {},

    hasGenerated($event) {},
  },

  watch: {
    selectedItem: function (newVal) {
      this.setCheckedItem();
    },
  },

  mounted() {
    // Get Data
    this.pagination();
    this.getSetting();

    this.$root.$on("paginateNurseRecapt", (m, y) => {
      this.month = m;
      this.year = y;
      this.pagination();
    });

    // this.setActiveButton()
  },
};
</script>

<style>
.text-medium {
  font-size: 15px;
}
</style>
